import React from 'react';
import {Form} from 'react-bootstrap';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { setStatusFilter, resetStatusFilter } from '../../../actions/filters';

class StatusFilter extends React.Component {
  state = {
    filter: this.props.statusFilter,
  };

  componentWillUnmount() {
    this.props.resetStatusFilter();
  }

  handleFilterChange = (event) => {
    let filter = parseInt(event.currentTarget.value);
    this.setState({filter});
    this.props.setStatusFilter(filter);
  };

  render() {
    return <Form.Group controlId="filter.status">
      <Form.Label>{gettext('Статус')}</Form.Label>
      <Form.Control as='select' size='sm' value={this.state.filter} onChange={this.handleFilterChange}>
        <option value={0}>{gettext('Все')}</option>
        <option value={1}>{gettext('Опубликовано')}</option>
        <option value={2}>{gettext('На модерации')}</option>
      </Form.Control>
    </Form.Group>
  }
}

let mapStateToProps = (state) => {
  return {
    statusFilter: state.filters.statusFilter,
  }
};

export default compose(connect(mapStateToProps, {setStatusFilter, resetStatusFilter}))(StatusFilter)
